import { render, staticRenderFns } from "./CardapioDigitalVideo.vue?vue&type=template&id=54208d08&scoped=true"
import script from "./CardapioDigitalVideo.vue?vue&type=script&lang=js"
export * from "./CardapioDigitalVideo.vue?vue&type=script&lang=js"
import style0 from "./CardapioDigitalVideo.vue?vue&type=style&index=0&id=54208d08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54208d08",
  null
  
)

export default component.exports